export default function getDateString(language, dayType, monthType, yearType) {
  const timestamp = new Date()

  return timestamp.toLocaleDateString(language, { day: dayType, month: monthType, year: yearType }).replace(/\//g, '.')
}
